module.exports = __webpack_public_path__ + "static/media/casa.41e829df.svg";